module.exports = __webpack_public_path__ + "img/indonesia.dc5c92d4.svg";